import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from "@material-ui/core/Checkbox";
import TextField from '@material-ui/core/TextField';
import PressureCorrection from './PressureCorrection';
import HydrometerCorrection from './HydrometerCorrection';
import { GravityConversionService } from '../../services/bunkermaster/GravityConversationService'

import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(Parameter, Unit, Fuel1, Fuel2, Target, Blend) {
    return { Parameter, Unit, Fuel1, Fuel2, Target, Blend };
}

const rows = [
    createData('Density', 'Kg / m3', 990.0, 900.0, '', 939),
    createData('Flash Point', '^C', '', '', '', ''),
    createData('Viscosity', 'mm2/s', '180.0', '11.0', '', '25.8'),
    createData('Viscosity Temperature', '0C', '50', '50', '50', '50'),
    createData('Micro Carbon Residue', '%m/m', '', '', '', ''),
    createData('Sulphur', '%m/m', '', '', '', ''),
    createData('Vanadium', '%m/m', '', '', '', ''),
    createData('Sodium ', 'mg/kg', '', '', '', ''),
    createData('Aluminium + mg/kg', '', '', '', '', ''),
];



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    textstyles: {
        color: '#ff4717'
    }
}));

function GravityConversation() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [close, setClose] = React.useState(true);
    const [hydro, setHydro] = React.useState(true);
    const [calcFields, setCalcFields] = React.useState({ Commodity: 2, ApplyHydrometerCorrection: false, ObservedGravityType: 1, ObservedGravityValue: "", ObservedTemperature: "", ObservedTemperatureUnit: 1, ObservedPressure: "", ObservedPressureUnit: 1, AlternateGravityType: 1, AlternateTemperature: "", AlternateTemperatureUnit: 1, AlternatePressure: "", AlternatePressureUnit: 1 });
    const [field, setField] = React.useState({ AlternateGravityValue: "" })
    /* const handleChangeon = (event, newValue) => {
        setValue(newValue);
        setChecked(event.target.checked);
    }; */
    const [checked, setChecked] = React.useState(true);
    const [validate, setValidate] = React.useState({ msg: "", textstyle: "userinfo" })
    const [FieldClass, setFieldClass] = React.useState({ ObservedGravityValue: true, ObservedTemperature: true, AlternateTemperature: true });
    const [error, setError] = React.useState({ errormsg: "", style: "  " })


    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const onGravity = (check) => {
        setCalcFields({ ...calcFields, ApplyHydrometerCorrection: check })
    }
    const handleChange = (check) => {
        
        setClose(check)

        /* if(check){
            setCalcFields({...calcFields,...{ObservedPressure:"",AlternatePressure:"",AlternatePressureUnit: "",ObservedPressureUnit: ""}})
        } */
    }
    const CalculateGravityConversion = () => {
        ////;
        if (calcFields["ObservedGravityValue"] === "" || calcFields["ObservedTemperature"] === "" || calcFields["AlternateTemperature"] === "") {
            let vali = validate;
            vali["textstyle"] = "newerrortext";
            vali["msg"] = "Fields is Required !";
            setValidate({ ...validate, ...vali });
            // let update = error;
            // update["errormsg"] = "";
            // setError({ ...error, ...update });

            if (calcFields["ObservedGravityValue"] === "") {
                let update = FieldClass;
                update["ObservedGravityValue"] = false;
                setFieldClass({ ...FieldClass, ...update });
            }
            if (calcFields["ObservedTemperature"] === "") {
                let update = FieldClass;
                update["ObservedTemperature"] = false;
                setFieldClass({ ...FieldClass, ...update });
            }
            if (calcFields["AlternateTemperature"] === "") {
                let update = FieldClass;
                update["AlternateTemperature"] = false;
                setFieldClass({ ...FieldClass, ...update });
            }
        }
        else {
            let vali = validate;
            vali["textstyle"] = "userinfo";
            vali["msg"] = "";
            setValidate({ ...validate, ...vali });

            switch (calcFields.Commodity) {
                case 1:
                    switch (calcFields.ObservedGravityType) {
                        case 1:
                            if (calcFields.ObservedGravityValue >= 611.5 && calcFields.ObservedGravityValue <= 1163) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Density must have a value between 611.5 and 1163";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (calcFields.ObservedTemperatureUnit === 1) {
                                if (calcFields.ObservedTemperature !== "" && calcFields.ObservedTemperature >= -50 && calcFields.ObservedTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (calcFields.ObservedTemperatureUnit === 2) {
                                if (calcFields.ObservedTemperature >= -58 && calcFields.ObservedTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (calcFields.AlternateTemperatureUnit === 1) {
                                if (calcFields.AlternateTemperature >= -50 && calcFields.AlternateTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (calcFields.AlternateTemperatureUnit === 2) {
                                if (calcFields.AlternateTemperature >= -58 && calcFields.AlternateTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 3:
                            if (calcFields.ObservedGravityValue >= -10 && calcFields.ObservedGravityValue <= 100) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "API Gravity must have a value between -10 and 100";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (calcFields.ObservedTemperatureUnit === 1) {
                                if (calcFields.ObservedTemperature !== "" && calcFields.ObservedTemperature >= -50 && calcFields.ObservedTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (calcFields.ObservedTemperatureUnit === 2) {
                                if (calcFields.ObservedTemperature >= -58 && calcFields.ObservedTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (calcFields.AlternateTemperatureUnit === 1) {
                                if (calcFields.AlternateTemperature >= -50 && calcFields.AlternateTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (calcFields.AlternateTemperatureUnit === 2) {
                                if (calcFields.AlternateTemperature >= -58 && calcFields.AlternateTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 2:
                            if (calcFields.ObservedGravityValue >= 0.6115 && calcFields.ObservedGravityValue <= 1.164) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Specific Gravity must have a value between 0.6115 and 1.164";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (calcFields.ObservedTemperatureUnit === 1) {
                                if (calcFields.ObservedTemperature !== "" && calcFields.ObservedTemperature >= -50 && calcFields.ObservedTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (calcFields.ObservedTemperatureUnit === 2) {
                                if (calcFields.ObservedTemperature >= -58 && calcFields.ObservedTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (calcFields.AlternateTemperatureUnit === 1) {
                                if (calcFields.AlternateTemperature >= -50 && calcFields.AlternateTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (calcFields.AlternateTemperatureUnit === 2) {
                                if (calcFields.AlternateTemperature >= -58 && calcFields.AlternateTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                    }
                    break;
                case 2:
                    switch (calcFields.ObservedGravityType) {
                        case 1:
                            if (calcFields.ObservedGravityValue >= 611.5 && calcFields.ObservedGravityValue <= 1163) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Density must have a value between 611.5 and 1163";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (calcFields.ObservedTemperatureUnit === 1) {
                                if (calcFields.ObservedTemperature !== "" && calcFields.ObservedTemperature >= -50 && calcFields.ObservedTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (calcFields.ObservedTemperatureUnit === 2) {
                                if (calcFields.ObservedTemperature >= -58 && calcFields.ObservedTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (calcFields.AlternateTemperatureUnit === 1) {
                                if (calcFields.AlternateTemperature >= -50 && calcFields.AlternateTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (calcFields.AlternateTemperatureUnit === 2) {
                                if (calcFields.AlternateTemperature >= -58 && calcFields.AlternateTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature must in \u00B0 F have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 3:
                            if (calcFields.ObservedGravityValue >= -10 && calcFields.ObservedGravityValue <= 100) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });

                            } else {
                                let update = error;
                                update["errormsg"] = "API Gravity must have a value between -10 and 100";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (calcFields.ObservedTemperatureUnit === 1) {
                                if (calcFields.ObservedTemperature !== "" && calcFields.ObservedTemperature >= -50 && calcFields.ObservedTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (calcFields.ObservedTemperatureUnit === 2) {
                                if (calcFields.ObservedTemperature >= -58 && calcFields.ObservedTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (calcFields.AlternateTemperatureUnit === 1) {
                                if (calcFields.AlternateTemperature >= -50 && calcFields.AlternateTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (calcFields.AlternateTemperatureUnit === 2) {
                                if (calcFields.AlternateTemperature >= -58 && calcFields.AlternateTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 2:
                            if (calcFields.ObservedGravityValue >= 0.6115 && calcFields.ObservedGravityValue <= 1.164) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Specific Gravity must have a value between 0.6115 and 1.164";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (calcFields.ObservedTemperatureUnit === 1) {
                                if (calcFields.ObservedTemperature !== "" && calcFields.ObservedTemperature >= -50 && calcFields.ObservedTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (calcFields.ObservedTemperatureUnit === 2) {
                                if (calcFields.ObservedTemperature >= -58 && calcFields.ObservedTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (calcFields.AlternateTemperatureUnit === 1) {
                                if (calcFields.AlternateTemperature >= -50 && calcFields.AlternateTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (calcFields.AlternateTemperatureUnit === 2) {
                                if (calcFields.AlternateTemperature >= -58 && calcFields.AlternateTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                    }
                    break;
                case 3:
                    switch (calcFields.ObservedGravityType) {
                        case 1:
                            if (calcFields.ObservedGravityValue >= 801.3 && calcFields.ObservedGravityValue <= 1163) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Density must have a value between 801.3 and 1163";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (calcFields.ObservedTemperatureUnit === 1) {
                                if (calcFields.ObservedTemperature !== "" && calcFields.ObservedTemperature >= -50 && calcFields.ObservedTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (calcFields.ObservedTemperatureUnit === 2) {
                                if (calcFields.ObservedTemperature >= -58 && calcFields.ObservedTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (calcFields.AlternateTemperatureUnit === 1) {
                                if (calcFields.AlternateTemperature >= -50 && calcFields.AlternateTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (calcFields.AlternateTemperatureUnit === 2) {
                                if (calcFields.AlternateTemperature >= -58 && calcFields.AlternateTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 3:
                            if (calcFields.ObservedGravityValue >= -10 && calcFields.ObservedGravityValue <= 45) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "API Gravity must have a value between -10 and 45";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (calcFields.ObservedTemperatureUnit === 1) {
                                if (calcFields.ObservedTemperature !== "" && calcFields.ObservedTemperature >= -50 && calcFields.ObservedTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (calcFields.ObservedTemperatureUnit === 2) {
                                if (calcFields.ObservedTemperature >= -58 && calcFields.ObservedTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (calcFields.AlternateTemperatureUnit === 1) {
                                if (calcFields.AlternateTemperature >= -50 && calcFields.AlternateTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (calcFields.AlternateTemperatureUnit === 2) {
                                if (calcFields.AlternateTemperature >= -58 && calcFields.AlternateTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 2:
                            if (calcFields.ObservedGravityValue >= 0.8017 && calcFields.ObservedGravityValue <= 1.164) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Specific Gravity must have a value between 0.8017 and 1.164";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (calcFields.ObservedTemperatureUnit === 1) {
                                if (calcFields.ObservedTemperature !== "" && calcFields.ObservedTemperature >= -50 && calcFields.ObservedTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (calcFields.ObservedTemperatureUnit === 2) {
                                if (calcFields.ObservedTemperature >= -58 && calcFields.ObservedTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Observed Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (calcFields.AlternateTemperatureUnit === 1) {
                                if (calcFields.AlternateTemperature >= -50 && calcFields.AlternateTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (calcFields.AlternateTemperatureUnit === 2) {
                                if (calcFields.AlternateTemperature >= -58 && calcFields.AlternateTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = "Alternate Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                    }
                    break;
            }
        }//else end here------
        if (error.errormsg === "") {
            const { Commodity, ApplyHydrometerCorrection, ObservedGravityType,
                ObservedTemperature, ObservedTemperatureUnit, ObservedGravityValue, ObservedPressure, ObservedPressureUnit,
                AlternateTemperature, AlternateTemperatureUnit, AlternatePressure, AlternatePressureUnit, AlternateGravityType } = calcFields
            let result = GravityConversionService.ConvertGravity({
                Commodity: Commodity,
                ApplyHydrometerCorrection: ApplyHydrometerCorrection,
                ObservedGravityType: ObservedGravityType,
                ObservedTemperature: ObservedTemperature,
                ObservedTemperatureUnit: ObservedTemperatureUnit,
                ObservedGravityValue: ObservedGravityValue,
                ObservedPressure: ObservedPressure,
                ObservedPressureUnit: ObservedPressureUnit,
                AlternateTemperature: AlternateTemperature,
                AlternateTemperatureUnit: AlternateTemperatureUnit,
                AlternatePressure: AlternatePressure,
                AlternatePressureUnit: AlternatePressureUnit,
                AlternateGravityType: AlternateGravityType
            })
            setField({ ...field, AlternateGravityValue: result == false ? "" : parseFloat(result).toFixed(2) })
        }
    }
    const onValuesChange = (value, field) => {
        

        let local = calcFields;
        local[field] = value;
        setCalcFields({ ...calcFields, ...local });
        setField({ ...field, ...{ AlternateGravityValue: "" } })

        if (calcFields["ObservedGravityValue"] !== "") {
            let update = FieldClass;
            update["ObservedGravityValue"] = true;
            setFieldClass({ ...FieldClass, ...update });
        }
        if (calcFields["ObservedTemperature"] !== "") {
            let update = FieldClass;
            update["ObservedTemperature"] = true;
            setFieldClass({ ...FieldClass, ...update });
        }
        if (calcFields["AlternateTemperature"] !== "") {
            let update = FieldClass;
            update["AlternateTemperature"] = true;
            setFieldClass({ ...FieldClass, ...update });
        }
       
      
    }
    const handleChangeon = (event, newValue) => {
        setValue(newValue);
        setChecked(event.target.checked);
    };

    const onResetenergy = () => {
        ;
        let update = error;
        update["errormsg"] = "";
        setError({ ...error, ...update });
        setField({ ...field, ...{ AlternateGravityValue: "" } })
        setCalcFields({ ...calcFields, ...{ ObservedGravityValue: "", ObservedTemperature: "", ObservedPressure: "", AlternateTemperature: "", AlternatePressure: "" } });
    }



    return (

        <div className={classes.root}>
            <div className="mar25">
                <div className="breadcurmbg mb25">
                    <span>Bunker Master </span>
                    <span className="bcarrow">  </span>
                    <span>Gravity conversion and correction</span>

                </div>

                <Box component="div" className="filtercontainer">
                    <Box component="div">

                        <Grid item xs={12} sm={12} md={12}>


                            <Box component="div" className="bunkarinput">

                                <Box component="div" className="pos_relative">
                                    <Box component="div" className="help_blk">
                                        <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                                        <Dialog
                                            open={open}
                                            onClose={handleClose}
                                            scroll={scroll}
                                            aria-labelledby="scroll-dialog-title"
                                            aria-describedby="scroll-dialog-description"
                                        >
                                            <DialogTitle id="scroll-dialog-title">Gravity Conversion and Correction</DialogTitle>
                                            <DialogContent dividers={scroll === 'paper'}>
                                                <DialogContentText
                                                    id="scroll-dialog-description"
                                                    ref={descriptionElementRef}
                                                    tabIndex={-1}
                                                >
                                                    <p>This module performs gravity conversions between different gravity units. It also performs gravity corrections due to the influence of temperature and/or pressure </p>
                                                    <p>The Correction Factor for Temperature and Pressure (CTPL or VCF) is calculated using the method specified in ASTM D 1250-04 and expressed with 5 decimal figures. For API the number of decimal places can be set in the Properties module.
                                                    </p>
                                                    <p>For atmospheric pressure, enter zero in the pressure field or leave the field blank. The calculations are then similar to the old 1980 tables.</p>
                                                    <p className="subtitle">Example 1 - Conversion from Density to API</p>
                                                    <img className="maxwidth100" src="/assets/images/Gravity-conversion-1.jpg"></img>
                                                    <p className="subtitle">Example 2 - Correction due to temperature influence</p>
                                                    <img className="maxwidth100" src="/assets/images/Gravity-conversion-2.jpg"></img>
                                                    <p className="subtitle">Example 3 - Correction due to temperature and pressure influence</p>
                                                    <img className="maxwidth100" src="/assets/images/Gravity-conversion-3.jpg"></img>
                                                    

                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleClose}>Close</Button>
                                            </DialogActions>
                                        </Dialog>
                                    </Box>
                                </Box>



                                <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>

                                    <Grid container spacing={3}>

                                        <Grid item row xs={12} sm={12} md={12}>
                                            <label className="widthauto">Commodity</label>
                                            <Select labelId="outlined-label5" className="mr20 bunkerselect" onChange={(e) => onValuesChange(e.target.value, "Commodity")} value={calcFields.Commodity}
                                            >
                                                <MenuItem value={1}>Crude Oil</MenuItem>
                                                <MenuItem value={2} selected>Refined Products</MenuItem>
                                                <MenuItem value={3}>Lubricating Oil</MenuItem>
                                            </Select>
                                            <span className={error.style}>{error.errormsg}</span>
                                            <span className={validate.textstyle}>{validate.msg}</span>
                                            <PressureCorrection onChange={handleChange} />
                                        </Grid>




                                    </Grid>

                                    <Grid container spacing={3}  >
                                        <Grid item xs={12} sm={12} md={12} lg={8} className="gravitycc">
                                            <p className="subtitle mt25 padb15">Observed Gravity</p>




                                            <Select labelId="outlined-label3" className="mr20 bunkerselect bigbox1 "
                                                onChange={(e) => onValuesChange(e.target.value, "ObservedGravityType")}
                                                value={calcFields.ObservedGravityType}
                                            >
                                                <MenuItem value={1}>Density, Kg/m3</MenuItem>
                                                <MenuItem value={3}>API Gravity,  <sup>o</sup>API</MenuItem>
                                                <MenuItem value={2}>Specific Gravity</MenuItem>
                                            </Select>

                                            <BootstrapInput
                                                className={FieldClass.ObservedGravityValue ? "mt0" : "error"}
                                                type="number"
                                                onChange={(e) => onValuesChange(e.target.value, "ObservedGravityValue")}
                                                value={calcFields.ObservedGravityValue}
                                            />


                                            at   <BootstrapInput
                                                className={FieldClass.ObservedTemperature ? "mr20 smallbox" : "error smallbox"}
                                                type="number"
                                                onChange={(e) => onValuesChange(e.target.value, "ObservedTemperature")}
                                                value={calcFields.ObservedTemperature}
                                            />
                                            <Select labelId="outlined-label4" className="mr20 bunkerselect smallbox"
                                                onChange={(e) => onValuesChange(e.target.value, "ObservedTemperatureUnit")}
                                                value={calcFields.ObservedTemperatureUnit}
                                            >
                                                <MenuItem value={1}> <sup>o</sup>C</MenuItem>
                                                <MenuItem value={2}> <sup>o</sup>F</MenuItem>
                                            </Select>
                                            <span> and </span>
                                            <BootstrapInput type="number" className="mr20  smallbox" disabled={close}
                                                onChange={(e) => onValuesChange(e.target.value, "ObservedPressure")}
                                                value={calcFields.ObservedPressure}
                                            />
                                            <Select labelId="outlined-label5" className="mr20 bunkerselect  smallbox" disabled={close} defaultValue="kPa"
                                                onChange={(e) => onValuesChange(e.target.value, "ObservedPressureUnit")}
                                                value={calcFields.ObservedPressureUnit}
                                            >
                                                <MenuItem value={1}>kPa</MenuItem>
                                                <MenuItem value={2}>Bar</MenuItem>
                                                <MenuItem value={3}>Psi</MenuItem>

                                            </Select>




                                            <Box component="div" className="padb15">
                                                <HydrometerCorrection onChange={onGravity} />
                                            </Box>


                                            <p className="subtitle padb15 ">Alternate Gravity</p>


                                            <Select labelId="outlined-label3" className="mr20 bunkerselect bigbox1  "
                                                onChange={(e) => onValuesChange(e.target.value, "AlternateGravityType")}
                                                value={calcFields.AlternateGravityType}
                                            >
                                                <MenuItem value={1}>Density, Kg/m3</MenuItem>
                                                <MenuItem value={3}>API Gravity,  <sup>o</sup>API</MenuItem>
                                                <MenuItem value={2}>Specific Gravity</MenuItem>
                                            </Select>

                                            <BootstrapInput type="number" className="mt0 " disabled={close} value={field.AlternateGravityValue}

                                            />

                                            at   <BootstrapInput type="number" className="mr20 smallbox"
                                                className={FieldClass.AlternateTemperature ? "mr20 smallbox" : "error smallbox"}

                                                onChange={(e) => onValuesChange(e.target.value, "AlternateTemperature")}
                                                value={calcFields.AlternateTemperature}
                                            />
                                            <Select labelId="outlined-label4" className="mr20 bunkerselect smallbox"
                                                onChange={(e) => onValuesChange(e.target.value, "AlternateTemperatureUnit")}
                                                value={calcFields.AlternateTemperatureUnit}
                                            >
                                                <MenuItem value={1}> <sup>o</sup>C</MenuItem>
                                                <MenuItem value={2}> <sup>o</sup>F</MenuItem>
                                            </Select>
                                            <span> and </span>
                                            <BootstrapInput type="number" className="mr20  smallbox" disabled={close}
                                                onChange={(e) => onValuesChange(e.target.value, "AlternatePressure")}
                                                value={calcFields.AlternatePressure}
                                            />
                                            <Select labelId="outlined-label5" className="mr20 bunkerselect  smallbox" disabled={close} defaultValue="kPa"
                                                onChange={(e) => onValuesChange(e.target.value, "AlternatePressureUnit")}
                                                value={calcFields.AlternatePressureUnit}
                                            >
                                                <MenuItem value={1}>kPa</MenuItem>
                                                <MenuItem value={2}>Bar</MenuItem>
                                                <MenuItem value={3}>Psi</MenuItem>

                                            </Select>

                                            <Box component="div" className="pt20">

                                                <button type="button" className={classes.btn1} onClick={onResetenergy}  >Reset</button>
                                                <button type="button" className={classes.btn2} onClick={CalculateGravityConversion} >Calculate</button>{''}
                                            </Box>

                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12} lg={4}>

                                            <Box component="div" className="resultbox">
                                                <p>Results</p>
                                                <Box component="div" className="bunkarinput resultinner">

                                                    <form className={classes.root} noValidate autoComplete="off">

                                                        <Box component="div" className=" gravitymisc1">
                                                            <label className="resultLabel"> Alternate Gravity  </label>
                                                            <TextField id="standard-basic  " value={field.AlternateGravityValue} />

                                                            <span className="resultmv"> </span>

                                                        </Box>
                                                    </form>
                                                </Box>



                                            </Box>

                                        </Grid>


                                    </Grid>

                                </FormControl>

                            </Box>


                        </Grid>



                    </Box>



                </Box>










            </div>
        </div>
    );
}
export default GravityConversation;
